// Headroom
import Headroom from "headroom.js";
// grab an element
var headerElement = document.querySelector(".main-header");
// Splide
import Splide from '@splidejs/splide';


//headroom options
var options = {
  // vertical offset in px before element is first unpinned
  offset: 0,
  // or you can specify offset individually for up/down scroll
  offset: {
    up: 100,
    down: 50
  },
  // scroll tolerance in px before state changes
  tolerance: 0,
  // or you can specify tolerance individually for up/down scroll
  tolerance: {
    up: 5,
    down: 0
  },
  // css classes to apply
  classes: {
    // when element is initialised
    initial: "headroom",
    // when scrolling up
    pinned: "headroom--scrolling-up",
    // when scrolling down
    unpinned: "headroom--scrolling-down",
    // when above offset
    top: "headroom--top",
    // when below offset
    notTop: "headroom--not-top",
    // when at bottom of scroll area
    bottom: "headroom--bottom",
    // when not at bottom of scroll area
    notBottom: "headroom--not-bottom",
    // when frozen method has been called
    frozen: "headroom--frozen",
    // multiple classes are also supported with a space-separated list
    pinned: "headroom--pinned foo bar"
  },
  // callback when pinned, `this` is headroom object
  onPin: function () { },
  // callback when unpinned, `this` is headroom object
  onUnpin: function () { },
  // callback when above offset, `this` is headroom object
  onTop: function () { },
  // callback when below offset, `this` is headroom object
  onNotTop: function () { },
  // callback when at bottom of page, `this` is headroom object
  onBottom: function () { },
  // callback when moving away from bottom of page, `this` is headroom object
  onNotBottom: function () { }
};

// construct an instance of Headroom, passing the element
var headroom = new Headroom(headerElement, options);
var body = document.querySelector('body');
if (!body.classList.contains('page--inventory')) {
  // initialise
  headroom.init();
}

// VidBG
var heroVidBg = document.getElementsByClassName('has-video-bg');
if (heroVidBg.length) {

  var video = (heroVidBg[0].getAttribute('data-video')) ? heroVidBg[0].getAttribute('data-video') : '';
  var poster = (heroVidBg[0].getAttribute('data-poster')) ? heroVidBg[0].getAttribute('data-poster') : '';

  new vidbg('.has-video-bg', {
    mp4: video, // URL or relative path to MP4 video
    poster: poster, // URL or relative path to fallback image
    overlay: true, // Boolean to display the overlay or not
    overlayColor: '#000', // The overlay color as a HEX
    overlayAlpha: 0.3 // The overlay alpha. Think of this as the last integer in RGBA()
  })
}


// Splide docs: https://splidejs.com/
var territoriesSliders = document.getElementsByClassName('splide__territories');
for (var i = 0, len = territoriesSliders.length; i < len; i++) {
  new Splide(territoriesSliders[i], {
    type: "loop",
    autoplay:true,
    rewind: true,
    speed: 600,
    pagination: true,
    autoHeight: true
  }).mount();
}

// Splide - Multiple Slides
var instagramFeedsSlider = document.getElementsByClassName('splide__feeds');
for (var i = 0, len = instagramFeedsSlider.length; i < len; i++) {
  new Splide(instagramFeedsSlider[i], {
    type:"loop",
    autoplay:true,
    rewind: true,
    perPage:3
  }).mount();
}

// access golbal Splide from component
window.Splide = Splide;
